import { CALL_API } from '../middleware/api'

export const ARQUEOS_REQUEST = 'ARQUEOS_REQUEST'
export const ARQUEOS_SUCCESS = 'ARQUEOS_SUCCESS'
export const ARQUEOS_FAILURE = 'ARQUEOS_FAILURE'

export function fetchArqueos(Machine, CustomerOrCustomers, StartDate, EndDate, Country, ContractType) {
  const params = new URLSearchParams()

  const addIfPresent = (key, val) => {
    if (val === undefined || val === null) return
    if (typeof val === 'string' && val.trim() === '') return
    params.append(key, val)
  }

  addIfPresent('Machine', Machine)

  // Accept string or array for customer(s)
  if (Array.isArray(CustomerOrCustomers)) {
    if (CustomerOrCustomers.length === 1) {
      addIfPresent('Customer', CustomerOrCustomers[0])
    } else if (CustomerOrCustomers.length > 1) {
      CustomerOrCustomers.forEach(id => addIfPresent('Customer', id))
    }
    // if empty array -> no Customer param
  } else {
    // single-customer legacy usage
    addIfPresent('Customer', CustomerOrCustomers)
  }

  addIfPresent('Country', Country)
  addIfPresent('StartDate', StartDate)
  addIfPresent('EndDate', EndDate)
  addIfPresent('ContractType', ContractType)

  const query = params.toString()

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: query ? `arqueos?${query}` : 'arqueos',
      authenticated: true,
      types: [ARQUEOS_REQUEST, ARQUEOS_SUCCESS, ARQUEOS_FAILURE]
    }
  }
}

export const ARQUEOS_SALES_REQUEST = 'ARQUEOS_SALES_REQUEST'
export const ARQUEOS_SALES_SUCCESS = 'ARQUEOS_SALES_SUCCESS'
export const ARQUEOS_SALES_FAILURE = 'ARQUEOS_SALES_FAILURE'

export function fetchSalesArqueos(BusinessModel, Customer, StartDate, EndDate, Country) {
  let params = ''

  if (BusinessModel !== undefined) {
    params += `&BusinessModel=${BusinessModel}`
  }

  if (Customer !== undefined) {
    params += `&Customer=${Customer}`
  }

  if (Country !== undefined) {
    params += `&Country=${Country}`
  }

  if (StartDate !== undefined) {
    params += `&StartDate=${StartDate}`
  }

  if (EndDate !== undefined) {
    params += `&EndDate=${EndDate}`
  }

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `arqueos/sales?${params}`,
      authenticated: true,
      types: [ARQUEOS_SALES_REQUEST, ARQUEOS_SALES_SUCCESS, ARQUEOS_SALES_FAILURE]
    }
  }
}

// Generated (lambda-like) sales arqueos (computed on-demand for a date range)
export const ARQUEOS_GENERATED_SALES_REQUEST = 'ARQUEOS_GENERATED_SALES_REQUEST'
export const ARQUEOS_GENERATED_SALES_SUCCESS = 'ARQUEOS_GENERATED_SALES_SUCCESS'
export const ARQUEOS_GENERATED_SALES_FAILURE = 'ARQUEOS_GENERATED_SALES_FAILURE'

export function fetchGeneratedSalesArqueos(StartDate, EndDate, BusinessModel, Customer, Country) {
  const params = new URLSearchParams()
  if (StartDate) params.append('StartDate', StartDate)
  if (EndDate) params.append('EndDate', EndDate)
  if (BusinessModel) params.append('BusinessModel', BusinessModel)
  if (Customer) params.append('Customer', Customer)
  if (Country) params.append('Country', Country)

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `arqueos/generated/sales?${params.toString()}`,
      authenticated: true,
      types: [ARQUEOS_GENERATED_SALES_REQUEST, ARQUEOS_GENERATED_SALES_SUCCESS, ARQUEOS_GENERATED_SALES_FAILURE]
    }
  }
}

// Persisted-only sales arqueos (reads new collection only)
export const ARQUEOS_PERSISTED_SALES_REQUEST = 'ARQUEOS_PERSISTED_SALES_REQUEST'
export const ARQUEOS_PERSISTED_SALES_SUCCESS = 'ARQUEOS_PERSISTED_SALES_SUCCESS'
export const ARQUEOS_PERSISTED_SALES_FAILURE = 'ARQUEOS_PERSISTED_SALES_FAILURE'

export function fetchPersistedSalesArqueos(StartDate, EndDate, BusinessModel, Customer, Country) {
  const params = new URLSearchParams()
  if (StartDate) params.append('StartDate', StartDate)
  if (EndDate) params.append('EndDate', EndDate)
  if (BusinessModel) params.append('BusinessModel', BusinessModel)
  if (Customer) params.append('Customer', Customer)
  if (Country) params.append('Country', Country)

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `arqueos/persisted/sales?${params.toString()}`,
      authenticated: true,
      types: [ARQUEOS_PERSISTED_SALES_REQUEST, ARQUEOS_PERSISTED_SALES_SUCCESS, ARQUEOS_PERSISTED_SALES_FAILURE]
    }
  }
}

// Generated (lambda-like) operational arqueos (computed on-demand for a date range)
export const ARQUEOS_GENERATED_OPERATIONAL_REQUEST = 'ARQUEOS_GENERATED_OPERATIONAL_REQUEST'
export const ARQUEOS_GENERATED_OPERATIONAL_SUCCESS = 'ARQUEOS_GENERATED_OPERATIONAL_SUCCESS'
export const ARQUEOS_GENERATED_OPERATIONAL_FAILURE = 'ARQUEOS_GENERATED_OPERATIONAL_FAILURE'

export function fetchGeneratedOperationalArqueos(StartDate, EndDate, Machine, Customer, Country) {
  const params = new URLSearchParams()
  if (StartDate) params.append('StartDate', StartDate)
  if (EndDate) params.append('EndDate', EndDate)
  if (Machine) params.append('Machine', Machine)
  if (Customer) params.append('Customer', Customer)
  if (Country) params.append('Country', Country)

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `arqueos/generated/operational?${params.toString()}`,
      authenticated: true,
      types: [ARQUEOS_GENERATED_OPERATIONAL_REQUEST, ARQUEOS_GENERATED_OPERATIONAL_SUCCESS, ARQUEOS_GENERATED_OPERATIONAL_FAILURE]
    }
  }
}

// Persisted-only operational arqueos (reads new collection only)
export const ARQUEOS_PERSISTED_OPERATIONAL_REQUEST = 'ARQUEOS_PERSISTED_OPERATIONAL_REQUEST'
export const ARQUEOS_PERSISTED_OPERATIONAL_SUCCESS = 'ARQUEOS_PERSISTED_OPERATIONAL_SUCCESS'
export const ARQUEOS_PERSISTED_OPERATIONAL_FAILURE = 'ARQUEOS_PERSISTED_OPERATIONAL_FAILURE'

export function fetchPersistedOperationalArqueos(StartDate, EndDate, Machine, Customer, Country, BusinessModel) {
  const params = new URLSearchParams()
  if (StartDate) params.append('StartDate', StartDate)
  if (EndDate) params.append('EndDate', EndDate)
  if (Machine) params.append('Machine', Machine)
  if (Customer) params.append('Customer', Customer)
  if (Country) params.append('Country', Country)
  if (BusinessModel) params.append('BusinessModel', BusinessModel)

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `arqueos/persisted/operational?${params.toString()}`,
      authenticated: true,
      types: [ARQUEOS_PERSISTED_OPERATIONAL_REQUEST, ARQUEOS_PERSISTED_OPERATIONAL_SUCCESS, ARQUEOS_PERSISTED_OPERATIONAL_FAILURE]
    }
  }
}

// Trigger generation (server will call lambda to persist daily 'generar')
export const ARQUEOS_GENERATE_RANGE_REQUEST = 'ARQUEOS_GENERATE_RANGE_REQUEST'
export const ARQUEOS_GENERATE_RANGE_SUCCESS = 'ARQUEOS_GENERATE_RANGE_SUCCESS'
export const ARQUEOS_GENERATE_RANGE_FAILURE = 'ARQUEOS_GENERATE_RANGE_FAILURE'

export function generateArqueosRange(StartDate, EndDate, types = ['sales','operational']) {
  // send a JSON string (middleware expects already-serialized body)
  const body = JSON.stringify({ StartDate, EndDate, Types: types })
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `arqueos/generate-range`,
      authenticated: true,
      body,
      types: [ARQUEOS_GENERATE_RANGE_REQUEST, ARQUEOS_GENERATE_RANGE_SUCCESS, ARQUEOS_GENERATE_RANGE_FAILURE]
    }
  }
}

export const ARQUEO_REQUEST = 'ARQUEO_REQUEST'
export const ARQUEO_SUCCESS = 'ARQUEO_SUCCESS'
export const ARQUEO_FAILURE = 'ARQUEO_FAILURE'

export function fetchArqueo(Serial) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `arqueos/${Serial}`,
      authenticated: true,
      types: [ARQUEO_REQUEST, ARQUEO_SUCCESS, ARQUEO_FAILURE]
    }
  }
}